import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Link } from 'plurall-ui'
import textReplace from 'utils/textReplace'

import styles from './Popover.module.css'

class Popover extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    content: PropTypes.string.isRequired,
    dataTest: PropTypes.string,
    dataTestId: PropTypes.string,
  }

  state = {
    showPopover: false,
    modalHtmlId: 'popover-modal-' + new Date().getMilliseconds() + Math.random(),
  }

  keyContainer = React.createRef()
  keyContent = React.createRef()

  setVisibility = evt => {
    const modalEl = document.getElementById(this.state.modalHtmlId)
    if (modalEl.classList.contains('popover-modal-hidden')) {
      modalEl.classList.remove('popover-modal-hidden')
      this.setPosition(evt.target)
    } else {
      modalEl.classList.add('popover-modal-hidden')
    }
  }

  setPosition = linkEl => {
    const modalEl = document.getElementById(this.state.modalHtmlId)
    const modalRect = modalEl.getBoundingClientRect()
    const modalParentElRect = linkEl.offsetParent.getBoundingClientRect()

    let modalLeft = 0 //by Css, modal max-width is 100%
    const modalRectWidth = modalRect.width
    if (modalRectWidth < modalParentElRect.width && linkEl.offsetLeft > modalRectWidth) {
      modalLeft = linkEl.offsetLeft - modalRectWidth
    }
    modalEl.style.top = linkEl.offsetTop + linkEl.offsetHeight + 'px'
    modalEl.style.left = modalLeft + 'px'
  }

  handleLinkClick = evt => {
    this.closePreviousModal()

    this.setVisibility(evt)
  }

  closePreviousModal = () => {
    const popoverModals = document.getElementsByClassName('popover-modal')
    let modal = null
    for (let i = 0; i < popoverModals.length; i++) {
      modal = popoverModals[i]
      if (modal.id !== this.state.modalHtmlId) {
        modal.classList.add('popover-modal-hidden')
      }
    }
  }

  render = () => {
    const {
      props: { children, content, dataTest, dataTestId },
    } = this

    return (
      <div
        ref={this.keyContainer}
        className={styles.popoverContainer}
        data-test={dataTest}
        data-test-id={dataTestId}
      >
        <div
          ref={this.keyContent}
          id={this.state.modalHtmlId}
          className={`popover-modal ${styles.popover} popover-modal-hidden`}
        >
          <div
            className={styles.contentClass}
            dangerouslySetInnerHTML={{ __html: textReplace(content) }}
          />

          <Icon
            onClick={this.setVisibility}
            className={styles.closeButton}
            color='red'
            type='close'
            size='small'
          />
        </div>
        <Link href={null} onClick={this.handleLinkClick}>
          {children}
        </Link>
      </div>
    )
  }
}

export default Popover
